import { defineCatalogue } from '../../i18n';

export const hintCatalogue = defineCatalogue(
  {
    about: 'Sobre {label}',
  },
  {
    about: 'About {label}',
  },
);

export const ht = hintCatalogue.t;
